import React from 'react';

const SecurityProtection = () => {
    return (
        <div className="p-5">
            <h1 className="text-center my-5 fontSize48">Security Protection</h1>
            
            <h2 className="my-4">Security Policies and Protection Policies</h2>
            <p>
                WISERBEE has privacy and security-conscious policies that apply to all of its information
                handling practices.
            </p>

            <h3 className="my-3">Contractual Privacy Protection for Customers</h3>
            <ul>
                <li>WISERBEE's contracts include confidentiality provisions that prohibit WISERBEE from
                    disclosing customer confidential information, including customer data, except under
                    certain defined circumstances, such as when required by law.</li>
                <li>WISERBEE agrees not to access customer's accounts, including customer data, except to
                    maintain the service, prevent or respond to technical or service problems, at a customer's
                    request in connection with a customer support issue, or where required by law.</li>
            </ul>

            <h3 className="my-3">Privacy Statement</h3>
            <p>
                For information collected on WISERBEE's Web sites, WISERBEE provides assurances
                around the types of information collected, how that information may be shared and how
                that information may be used. WISERBEE offers individuals the opportunity to manage
                their receipt of marketing and other non-transactional communications. WISERBEE offers
                individuals the opportunity to update or change the information they provide.
            </p>

            <h3 className="my-3">Code of Conduct, Confidentiality Agreements, and Information Security Policies</h3>
            <p>
                Every WISERBEE employee must follow WISERBEE's code of conduct, sign a
                confidentiality and non-disclosure agreement as a condition of employment, and follow
                WISERBEE's information security policies.
            </p>

            <h2 className="my-4">Practices</h2>
            <p>
                WISERBEE's privacy and security program includes having the appropriate people in
                place to create, manage and drive security, privacy and policy and communicating with
                personnel about current issues and best practices.
            </p>

            <h3 className="my-3">Internal Training and Communications</h3>
            <p>
                WISERBEE regularly communicates with personnel about its obligation to safeguard confidential
                information. WISERBEE provides online training on confidentiality, privacy, and information
                security for all new employees. All WISERBEE personnel are required to complete annual privacy
                and security training and are tested on the materials presented. WISERBEE communicates with
                all personnel about privacy and information security awareness throughout the year.
            </p>

            <h3 className="my-3">Customer End User Awareness</h3>
            <p>
                WISERBEE encourages all of its customers and users to adopt industry-standard solutions to
                secure and protect their authentication credentials, networks, servers, and computers. WISERBEE
                communicates with its customers about current issues and trends and informs customers about
                security issues when necessary and appropriate.
            </p>

            <h2 className="my-4">People</h2>
            <p>
                WISERBEE has an Information Security Team under the Chief Technology Officer, that
                is responsible for managing and maintaining the Information Security Management
                System and program.
            </p>
            <p>
                The Chief Privacy Officer is responsible for WISERBEE's privacy program, including
                compliance with applicable privacy and data-protection laws.
            </p>
            <p>
                The Information Security Risk and Compliance Manager is responsible for ensuring
                policies are kept up to date, enforced and organizational risks are identified and mitigated
                tactically and strategically through security policies. Additionally, all WISERBEE
                personnel are required to follow WISERBEE's confidentiality, privacy, and information
                security policies.
            </p>

            <h2 className="my-4">Default Privacy and Security Features</h2>
            
            <h3 className="my-3">Application Features that Protect Customer Data</h3>
            <ul>
                <li>Connection to the WiserBee service is via transport layer security (TLS), ensuring that its
                    customers have a secure connection to their data.</li>
                <li>Individual user sessions are uniquely identified and re-verified with each transaction through tokenization process.</li>
                <li>Application logs record the creator, last updated, timestamps, and originating IP address for every
                    record and transaction completed.</li>
                <li>Customers' passwords are not accessible by WISERBEE personnel.</li>
                <li>Security controls include unique, non-predictable session tokens, configurable session timeout
                    values, password policies, sharing rules, and user profiles.</li>
            </ul>

            <h3 className="my-3">Logical Separation of Customer Data</h3>
            <p>
                Hardware and software configurations are designed to provide secure logical separation of
                customer data. The WiserBee service supports delegated authentication.
            </p>

            <h3 className="my-3">Network Security Measures</h3>
            <ul>
                <li>Multiple layers of external firewalls</li>
                <li>Intrusion-detection & prevention sensors</li>
                <li>Security information and event management tools</li>
                <li>Continuous vulnerability scanning and external penetration testing</li>
            </ul>

            <h3 className="my-3">Redundancy and Scalability</h3>
            <p>
                The WiserBee service is highly scalable and redundant, allowing for fluctuation in demand and
                expansion of users while greatly reducing the threat of outages. Load-balanced networks, pools of
                application servers, and clustered databases are features of WISERBEE's design.
            </p>

            <h3 className="my-3">Disaster Recovery</h3>
            <p>
                All customer data is stored in secure data centers of AWS/GCP/Contabo and is replicated over
                secure links to a disaster recovery sites provided by AWS/GCP/Contabo. This design provides the
                ability to rapidly restore the WiserBee service in the case of a catastrophic event.
            </p>

            <h3 className="my-3">Customer-Controlled Privacy and Security Settings</h3>
            <ul>
                <li>Customers may determine which of their respective designees can access different categories of data.</li>
                <li>Customers may set customizable password rules.</li>
                <li>Customers may define log-off times for inactivity.</li>
            </ul>
        </div>
    );
};

export default SecurityProtection;